import React from "react";

import { config } from "@app/config";

type Locales = {
  [key: string]: string;
};

type Shop = {
  name: string;
};

export type Props = {
  config: typeof config;
  locales?: Locales;
  shop?: Shop;
  id?: string;
  className?: string;
};

export function Icon({ id, className }: Props) {
  const href = `${window.SHOPIFY_DATA.assets.spritesheet}#${id}`;

  if (!id) return null;

  return (
    <svg className={className}>
      <use xlinkHref={href}></use>
    </svg>
  );
}
